import { InjectionToken } from '@angular/core'
import { CameraRef } from './camera-ref'

export const CAMERA_REF: InjectionToken<CameraRef> = new InjectionToken<
  CameraRef
>('CameraRef')
